import { ISteps } from '../../interfaces/step.interface';

export const stepperConfig: ISteps = {
  televisitGenericBooking: [
    {
      stepId: 'profile-selection',
      stepTitle: 'step.profile',
      hasTipside: false,
    },
    {
      stepId: 'request-selection',
      stepTitle: 'step.request',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  televisitSpecialistBooking: [
    {
      stepId: 'profile-selection',
      stepTitle: 'step.profile',
      hasTipside: false,
    },
    {
      stepId: 'specialist-categorization-selection',
      stepTitle: 'step.specialist',
      hasTipside: true,
    },
    {
      stepId: 'request-selection',
      stepTitle: 'step.request',
      hasTipside: true,
    },
    {
      stepId: 'date-selection',
      stepTitle: 'step.date',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  genericConsultation: [
    {
      stepId: 'mode-selection',
      isVideoView: true,
      stepTitle: 'step.mode',
      hasTipside: false,
    },
    {
      stepId: 'profile-selection',
      isVideoView: false,
      stepTitle: 'step.profile',
      hasTipside: false,
    },
    {
      stepId: 'request-selection',
      stepTitle: 'step.request',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  specialistConsultation: [
    {
      stepId: 'mode-selection',
      isVideoView: true,
      stepTitle: 'step.mode',
      hasTipside: false,
    },
    {
      stepId: 'profile-selection',
      isVideoView: false,
      stepTitle: 'step.profile',
      hasTipside: false,
    },
    {
      stepId: 'specialist-categorization-selection',
      stepTitle: 'step.specialist',
      hasTipside: true,
    },
    {
      stepId: 'request-selection',
      stepTitle: 'step.request',
      hasTipside: true,
    },
    {
      stepId: 'date-selection',
      stepTitle: 'step.date',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  carePathway: [
    {
      stepId: 'profile-selection',
      stepTitle: 'step.profile',
      hasTipside: false,
    },
    {
      stepId: 'specialist-categorization-selection',
      stepTitle: 'step.specialist',
      hasTipside: true,
    },
    {
      stepId: 'request-selection',
      stepTitle: 'step.request',
      hasTipside: true,
    },
    {
      stepId: 'date-selection',
      stepTitle: 'step.date',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  careManager: [
    {
      stepId: 'recap-care-manager',
      stepTitle: 'step.intro',
      hasTipside: false,
    },
    {
      stepId: 'profile-selection-care-manager',
      stepTitle: 'step.profile',
      hasTipside: false,
    },
    {
      stepId: 'profile-selection-input',
      stepTitle: 'step.confirmProfile',
      hasTipside: false,
    },
    {
      stepId: 'one-radio-alimentation',
      stepTitle: 'step.documents',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  discoverCarePathway: [
    {
      stepId: 'profile-selection',
      stepTitle: 'step.profile',
      hasTipside: true,
    },
    {
      stepId: 'request-selection',
      stepTitle: 'step.request',
      hasTipside: true,
    },
    {
      stepId: 'one-radio-alimentation',
      stepTitle: 'step.documents',
      hasTipside: true,
    },
    {
      stepId: 'date-selection',
      stepTitle: 'step.date',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  vet: [
    {
      stepId: 'mode-selection',
      isVideoView: true,
      stepTitle: 'step.mode',
      hasTipside: false,
    },
    {
      stepId: 'request-selection',
      isVideoView: false,
      stepTitle: 'step.request',
      hasTipside: false,
    },
    {
      stepId: 'date-selection',
      stepTitle: 'step.date',
      hasTipside: false,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: false,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  newValutation: [
    {
      stepId: 'intro',
      stepTitle: 'step.intro',
      hasTipside: false,
    },
    {
      stepId: 'days-picker',
      stepTitle: 'step.when',
      hasTipside: false,
    },
    {
      stepId: 'body-parts',
      stepTitle: 'step.where',
      hasTipside: false,
    },
    {
      stepId: 'symptoms',
      stepTitle: 'step.symptoms',
      hasTipside: false,
    },
    {
      stepId: 'survey',
      stepTitle: 'step.questions',
      hasTipside: false,
    },
    {
      stepId: 'summary-valutation',
      stepTitle: 'step.summary',
      hasTipside: false,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  psyConsultation: [
    {
      stepId: 'mode-selection',
      isVideoView: true,
      stepTitle: 'step.mode',
      hasTipside: false,
    },
    {
      stepId: 'profile-selection',
      isVideoView: false,
      stepTitle: 'step.profile',
      hasTipside: false,
    },
    {
      stepId: 'request-selection',
      stepTitle: 'step.request',
      hasTipside: true,
    },
    {
      stepId: 'date-selection',
      stepTitle: 'step.date',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
  modify: [
    {
      stepId: 'date-selection',
      stepTitle: 'step.date',
      hasTipside: true,
    },
    {
      stepId: 'summary',
      stepTitle: 'step.summary',
      hasTipside: true,
    },
    {
      stepId: 'ty-page',
      stepTitle: '',
      hasTipside: false,
    },
  ],
};
